<template>
  <div class="back-score">
    <img :src="backImg" />
    <span v-if="honorType === 1">全国<label>64</label>强战队</span>
    <span v-if="honorType === 2">全国<label>32</label>强战队</span>
    <span v-if="honorType === 3">全国<label>16</label>强战队</span>
    <span v-if="honorType === 4">全国<label>8</label>强战队</span>
    <span v-if="honorType === 5">{{ areaHonorName }}</span>
    <span class="beforeThree" v-if="honorType === 6">全国冠军战队</span>
    <span class="beforeThree" v-if="honorType === 7">全国亚军战队</span>
    <span class="beforeThree" v-if="honorType === 8">全国季军战队</span>
    <span class="beforeThree-2" v-if="honorType === 9"> 竞技场{{ areaHonorName }}冠军战队</span>
    <span class="beforeThree-2" v-if="honorType === 10"> 竞技场{{ areaHonorName }}亚军战队</span>
    <span class="beforeThree-2" v-if="honorType === 11"> 竞技场{{ areaHonorName }}季军战队</span>
  </div>
</template>
<script>
export default {
  name: "rankingImg",
  data() {
    return {
      backImg: "",
    };
  },
  props: {
    honorType: {
      type: Number,
      default: 0,
    },
    areaHonorName: {
      type: String,
      default: "",
    },
  },
  mounted() {
    // 先固定赛季
    const year = '2025';
    const season = 'summer';
    if (
      this.honorType === 1 ||
      this.honorType === 2 ||
      this.honorType === 3 ||
      this.honorType === 4
    ) {
      this.backImg = require(`../../../assets/images/squirrelCup/${year}/${season}/countryGame/sixFour.png`);
    } else if (this.honorType === 5) {
      this.backImg = require(`../../../assets/images/squirrelCup/${year}/${season}/countryGame/areaFirst.png`);
    } else if (this.honorType === 6) {
      this.backImg = require(`../../../assets/images/squirrelCup/${year}/${season}/countryGame/first.png`);
    } else if (this.honorType === 7) {
      this.backImg = require(`../../../assets/images/squirrelCup/${year}/${season}/countryGame/second.png`);
    } else if (this.honorType === 8) {
      this.backImg = require(`../../../assets/images/squirrelCup/${year}/${season}/countryGame/third.png`);
    } else if (this.honorType === 9) {
      this.backImg = require(`../../../assets/images/squirrelCup/${year}/${season}/countryGame/jjcFirst.png`);
    } else if (this.honorType === 10) {
      this.backImg = require(`../../../assets/images/squirrelCup/${year}/${season}/countryGame/jjcSecond.png`);
    } else if (this.honorType === 11) {
      this.backImg = require(`../../../assets/images/squirrelCup/${year}/${season}/countryGame/jjcThird.png`);
    } else if (this.honorType === 12) {
      this.backImg = require(`../../../assets/images/squirrelCup/${year}/${season}/countryGame/quanguo_si.png`);
    }
  },
};
</script>
<style lang="less" scoped>
.back-score {
  width: 90%;
  height: 210px;
  margin: 32px auto;
  position: relative;
  img {
    display: block;
    width: 100%;
    height: 100%;
  }
  span {
    position: absolute;
    display: flex;
    font-size: 56px;
    // line-height: 70px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    // line-height: 80px;
    text-shadow: 0px 2px 12px rgba(0, 0, 0, 0.35);
    bottom: 105px;
    right: 20px;
    transform: translateY(50%);
    align-items: center;
    label {
      font-size: 70px;
    }
  }
  .beforeThree {
    width: 270px;
    height: 128px;
    font-size: 64px;
    font-family: MFJianHei_Noncommercial-Regular, MFJianHei_Noncommercial;
    font-weight: 400;
    color: #ffffff;
    line-height: 64px;
    text-shadow: 0px 2px 12px rgba(161, 11, 11, 0.35);
    text-align: center;
  }
  .beforeThree-2 {
    width: 340px;
    height: 128px;
    font-family: MFJianHei_Noncommercial-Regular, MFJianHei_Noncommercial;
    font-weight: 400;
    color: #ffffff;
    line-height: 60px;
    text-shadow: 0px 2px 12px rgba(161, 11, 11, 0.35);
    text-align: center;
  }
}
</style>
